
<template>
  <div class="text_page" style="font-size:18px;">  
    
      <div class="download_buttons">
        <a v-if="item.credits_word > 0" class="btn_down" :href="'https://www.mysong.co.il/download/press/' + item.id + '?type=credits'"><i class="material-icons dp48">file_download</i> הורדת קרדיטים</a>
      </div>

     <div class="content" v-html="item.credits"></div>
  </div>
</template>

<script>
export default {
  props: ["widgets", "item"],
  created(){
    
    
  }
}
</script>

<style scoped>
.text_page .content { padding: 10px 40px; line-height: 1.5; }
</style>